import React, { useId } from "react";

export default function BrandLogo({ className = "", size = 40 }) {
  const gradId = useId().replace(/:/g, "");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#344767" />
          <stop offset="100%" stopColor="#5e72e4" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="7" fill={`url(#${gradId})`} />
      <path
        fill="#ffffff"
        opacity="0.95"
        d="M8 26V14h5v12H8zm7 0V10h5v16h-5zm7 0v-8h5v8h-5z"
      />
      <rect x="10" y="17" width="1.5" height="1.5" rx="0.3" fill="#344767" />
      <rect x="12.5" y="17" width="1.5" height="1.5" rx="0.3" fill="#344767" />
      <rect x="17" y="13" width="1.5" height="1.5" rx="0.3" fill="#344767" />
      <rect x="19.5" y="13" width="1.5" height="1.5" rx="0.3" fill="#344767" />
      <rect x="17" y="16.5" width="1.5" height="1.5" rx="0.3" fill="#344767" />
      <rect x="24" y="21" width="1.5" height="1.5" rx="0.3" fill="#344767" />
      <rect x="26.5" y="21" width="1.5" height="1.5" rx="0.3" fill="#344767" />
    </svg>
  );
}
